import { useEffect, useState } from "react";

/**
 * Sincroniza con el toggle de tema de la app (`class` `dark` en `document.body`,
 * ver `components/navbar` / `FixedPlugin`). Necesario para librerías que no usan Tailwind.
 */
export function useBodyDarkClass() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof document === "undefined") return false;
    return document.body.classList.contains("dark");
  });

  useEffect(() => {
    const el = document.body;
    const read = () => setIsDark(el.classList.contains("dark"));
    read();
    const mo = new MutationObserver(read);
    mo.observe(el, { attributes: true, attributeFilter: ["class"] });
    return () => mo.disconnect();
  }, []);

  return isDark;
}
